import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TmsAmbarService} from "../ctl-tms-ambar.service";

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private tmsAmbarService: TmsAmbarService) {
  }

  getData(control: any) {
    let baseEntity = control?.dlistMetadata?.baseEntity
    if (this.tmsAmbarService.yetkiKontrol) {
      baseEntity = baseEntity + '?AmbarTuru=Y'
    }
    const dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select(['Ad', 'Kod', 'Sifre', 'AktifEh', 'AmbarYerTakipEh']);
    const filterArr:any[] = [];

    if (this.tmsAmbarService.controlCondition) {
      this.tmsAmbarService.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }

}
